module.exports = __webpack_public_path__ + "img/EMR16-512.4a0decc1.png";